import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { AutocompleteProps } from '@components/atoms';
import { Autocomplete } from '@components/atoms';

export type FormAutocompleteProps = AutocompleteProps;

export const FormAutocomplete: FC<FormAutocompleteProps> = props => {
  const { control, formState } = useFormContext();
  const error = formState.errors[props.name];

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...props}
          textFieldProps={{ error: !!error, helperText: error?.message as string, ...props.textFieldProps, ...field }}
          onChange={(_, data) => field.onChange(data)}
        />
      )}
    />
  );
};
